import { render, staticRenderFns } from "./ContentList.vue?vue&type=template&id=453f58f2&scoped=true&"
import script from "./ContentList.vue?vue&type=script&lang=ts&"
export * from "./ContentList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453f58f2",
  null
  
)

export default component.exports